<!-- 关联实体 -->
<template>
  <div v-loading="loading">
    <div class="container">
      <div class="containerBox">
        <div class="search">
          <div class="searchBox">
            <span class="searchtitle">联盟名称</span>
            <el-select
              class="vin-input"
              v-model="unionId"
              filterable
              clearable
              remote
              reserve-keyword
              @visible-change="unionVisibleChange($event)"
              placeholder="请输入联盟名称"
              @change="unionChange"
            >
              <el-option
                v-for="optionItem in unionList"
                :key="optionItem.UnionId"
                :data-msg="optionItem"
                :label="optionItem.UnionName"
                :value="optionItem.UnionId"
              ></el-option>
            </el-select>
            <el-button
              class="btn-primary"
              @click="submitApply"
              :disabled="isJoin"
              >申请加入</el-button
            >
          </div>
        </div>
        <div class="search-result" v-if="!isNonResult">
          <div class="result-row">
            <div class="result-logo-cell">
              <div class="key">联盟Logo</div>
              <div class="value">
                <el-image
                  class="menu-image"
                  fit="fill"
                  :src="downloadUrl + unionData.LogoUrl"
                  :onerror="defaultImg"
                  :title="unionData.Name"
                />
              </div>
            </div>
            <div class="result-cell"></div>
          </div>
          <div class="result-row">
            <div class="result-cell">
              <div class="key">联盟名称</div>
              <div class="value">
                <el-badge value="已加入" v-if="unionData.IsJoin">
                  <span>{{ unionData.Name }}</span>
                </el-badge>
                <span v-else>{{ unionData.Name }}</span>
              </div>
            </div>
            <div class="result-cell">
              <div class="key">联盟简称</div>
              <div class="value">
                <span>{{ unionData.Abbr }}</span>
              </div>
            </div>
          </div>
          <div class="result-row">
            <div class="result-cell">
              <div class="key">联系人</div>
              <div class="value">
                <span>{{ unionData.Contactor }}</span>
              </div>
            </div>
            <div class="result-cell">
              <div class="key">联系电话</div>
              <div class="value">
                <span>{{ unionData.PhoneNum }}</span>
              </div>
            </div>
          </div>
          <div class="result-row">
            <div class="result-cell">
              <div class="key">主营配件</div>
              <div class="value">
                <span>{{ unionData.MainPartName }}</span>
              </div>
            </div>
            <div class="result-cell">
              <div class="key">主营车型</div>
              <div class="value">
                <span>{{ unionData.MainVehicle }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [],
  data() {
    return {
      defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE_square + '"',
      downloadUrl: this.$util.QN_URL_BASE,
      loading: false,
      unionData: {},
      unionList: [],
      isNonResult: false,
      unionId: "",
      isJoin: false,
    };
  },
  mounted() {},
  methods: {
    unionChange() {
      this.loading = true;
      this.$util
        .axiosGet({
          url: "/api/EntpUnions/GetUnionData",
          data: {
            UnionId: this.unionId,
          },
          hideLoading: true,
        })
        .then((res) => {
          if (res.data) {
            this.unionData = res.data;
            this.isJoin = res.data.IsJoin;
            this.isNonResult = false;
          } else this.isNonResult = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    unionVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.unionId) {
          if (that.unionList.length == 1) that.searchUnions('');
        } else {
          if (that.unionList.length == 0) that.searchUnions('');
        }
      }
    },
    searchUnions(key) {
      this.$util
        .searchUnions(key)
        .then((data) => {
          this.unionList = data;
        })
        .catch(() => {});
    },
    submitApply() {
      let that = this;
      if (that.unionData.UnionId) {
        this.$prompt("请填写申请内容", "提示", {
          confirmButtonText: "提交申请",
          cancelButtonText: "取消申请",
        })
          .then(({ value }) => {
            that.loading = true;
            that.$util
              .axiosPost({
                url:
                  '/api/EntpUnions/SubmitUnionApplys',
                data: { UnionId: that.unionData.UnionId, Message: value },
                hideLoading: true,
              })
              .then(() => {
                that.$util.successMsg("已成功提交申请，请耐心等候对方审核");
                that.$emit("closeDialog", true);
              })
              .finally(() => {
                that.loading = false;
              });
          })
          .catch(() => {});
      }
    },
  },
};
</script>
<style lang="less" scoped>
.searchtitle {
  font-size: 18px;
  font-weight: bold;
  margin-right: 5px;
}
.search-result {
  width: 900px;
  margin: 0 auto;
  padding-top: 30px;
  border-bottom: 1px solid #dcdfe6;

  .result-row {
    display: flex;
    border-right: 1px solid #dcdfe6;
  }
  .result-cell {
    width: 50%;
    display: flex;
    align-items: center;
    border-top: 1px solid #dcdfe6;

    .key {
      height: 50px;
      line-height: 50px;
      width: 100px;
      text-align: center;
      background-color: #f2f6fc;
      border-left: 1px solid #dcdfe6;
      padding-right: 10px;
    }
    .value {
      width: 200px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      border-left: 1px solid #dcdfe6;
    }
  }

  .result-logo-cell {
    width: 50%;
    display: flex;
    align-items: center;
    border-top: 1px solid #dcdfe6;

    .key {
      height: 100px;
      line-height: 100px;
      width: 100px;
      text-align: center;
      background-color: #f2f6fc;
      border-left: 1px solid #dcdfe6;
      padding-right: 10px;
    }
    .value {
      display: flex;
      width: 200px;
      height: 100px;
      line-height: 100px;
      text-align: center;
      justify-content: center;
      align-items: center;
      border-left: 1px solid #dcdfe6;
    }
  }
}
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  height: 400px;
}
.containerBox {
  margin-top: 30px;
  width: 1440px;
}
.search {
  width: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.searchBox {
  width: 80%;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: center;
  .vin-input {
    width: 400px;
    padding-right: 5px;
  }
}
.menu-image {
  width: 80px;
  height: 80px;
  overflow: hidden;
  border-radius: 16px;
}
</style>